import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  title: {
    margin: '0 0 20px 0',
    color: theme.colors.light.freshPowder,
    fontWeight: 700,
    fontSize: 16,
    textAlign: 'center',
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginBottom: 16,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));
